<template>
  <div class="imgVerAltList">
    <div v-for="(item, index) in list" :key="index" class="list-item">
      <div class="g-box">
        <div class="list-item-cont">
          <div class="list-item-cap">{{ item.title }}</div>
          <div class="list-item-tit" v-html="item.content"></div>
        </div>
        <div
          class="list-item-img"
          :style="{
            backgroundImage: 'url(' + item.image + ')'
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      pageSize: 10000000
    };
  },
  components: {},
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      await this.getListAndInfo();
    }
  }
};
</script>
<style lang="less">
.imgVerAltList {
  padding: 45px 0;
  .list-item {
    padding: 44px 0;
    &:nth-child(2n) {
      background-color: #f2f3f7;
      .g-box {
        flex-direction: row-reverse;
      }
      .list-item-img {
        margin-left: 0;
      }
      .list-item-cont {
        margin-left: auto;
      }
    }
  }
  .g-box {
    display: flex;
    align-items: center;
  }
  .list-item-img {
    margin-left: auto;
    flex-shrink: 0;
    width: 318px;
    height: 364px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .list-item-cont {
    width: 600px;
  }
  .list-item-cap {
    color: #606060;
    font-size: 28px;
  }
  .list-item-tit {
    color: #979797;
    font-size: 18px;
    margin-top: 40px;
    line-height: 32px;
  }
}
</style>
